import React from "react";
import { View, Text, ScrollView, Image, TouchableOpacity } from "react-native";
import { FontAwesome5 } from "@expo/vector-icons";
import { MaterialIcons, Feather } from "@expo/vector-icons";
import { FormattedMessage } from 'react-intl';

import HeaderDefault from "../../components/HeaderDefault";

import styles from "./styles";;

const SelectPixKey = ({ navigation }) => {
    return (
        <>
            <HeaderDefault title={<FormattedMessage id="selectPixKey.pixSelecioneChave"/>} />

            <View style={styles.container}>
                <View style={styles.list}>
                    <View style={styles.itemList}>
                        <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate('PhonePix')}>
                            <View style={styles.contentItems}>
                                <Image source={require('../../../assets/imgs/phone.png')} style={{ width: 12, height: 19, marginTop: 5 }} />
                                <Text style={styles.textItemList}><FormattedMessage id="selectPixKey.celular"/></Text>
                            </View>
                            <MaterialIcons
                                name="keyboard-arrow-right"
                                size={25}
                                color="#2C2C2E"
                            />
                        </TouchableOpacity>
                        <View style={styles.hrLine}></View>
                    </View>
                    <View style={styles.itemList}>
                        <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate('EmailPix')}>
                            <View style={styles.contentItems}>
                                <Image source={require('../../../assets/imgs/email.png')} style={{ width: 20, height: 20, marginTop: 5 }} />
                                <Text style={styles.textItemList}><FormattedMessage id="selectPixKey.email"/></Text>
                            </View>
                            <MaterialIcons
                                name="keyboard-arrow-right"
                                size={25}
                                color="#2C2C2E"
                            />
                        </TouchableOpacity>
                        <View style={styles.hrLine}></View>
                    </View>
                    <View style={styles.itemList}>
                        <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate('IdentityDocumentPix')}>
                            <View style={styles.contentItems}>
                                <Image source={require('../../../assets/imgs/file.png')} style={{ width: 17, height: 20, marginTop: 5 }} />
                                <Text style={styles.textItemList}><FormattedMessage id="selectPixKey.cpfCnpj"/></Text>
                            </View>
                            <MaterialIcons
                                name="keyboard-arrow-right"
                                size={25}
                                color="#2C2C2E"
                            />
                        </TouchableOpacity>
                        <View style={styles.hrLine}></View>
                    </View>
                    <View style={styles.itemList}>
                        <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate('RandomKeyPix')}>
                            <View style={styles.contentItems}>
                                <Image source={require('../../../assets/imgs/key.png')} style={{ width: 20, height: 20, marginTop: 5 }} />
                                <Text style={styles.textItemList}><FormattedMessage id="selectPixKey.chaveAleatoria"/></Text>
                            </View>
                            <MaterialIcons
                                name="keyboard-arrow-right"
                                size={25}
                                color="#2C2C2E"
                            />
                        </TouchableOpacity>
                        <View style={styles.hrLine}></View>
                    </View>
                    <View style={styles.itemList}>
                        <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate('BankAccountPix')}>
                            <View style={styles.contentItems}>
                                <Image source={require('../../../assets/bank.png')} style={{ width: 22, height: 20, marginTop: 5 }} />
                                <Text style={styles.textItemList}><FormattedMessage id="selectPixKey.agencia&Conta"/></Text>
                            </View>
                            <MaterialIcons
                                name="keyboard-arrow-right"
                                size={25}
                                color="#2C2C2E"
                            />
                        </TouchableOpacity>
                        <View style={styles.hrLine}></View>
                    </View>
                    <View style={styles.itemList}>
                        <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate('QrCodeTransferPix')}>
                            <View style={styles.contentItems}>
                                <Image source={require('../../../assets/imgs/qrcode.png')} style={{ width: 20, height: 20, marginTop: 5 }} />
                                <Text style={styles.textItemList}><FormattedMessage id="selectPixKey.qrCode"/></Text>
                            </View>
                            <MaterialIcons
                                name="keyboard-arrow-right"
                                size={25}
                                color="#2C2C2E"
                            />
                        </TouchableOpacity>
                        <View style={styles.hrLine}></View>
                    </View>
                </View>
            </View>
        </>
    );
}

export default SelectPixKey;